/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { SortableHandle } from "react-sortable-hoc";

/* components */
import { Panel } from "react-bootstrap";

class CollectionAccordion extends Component {
	constructor(props) {
		super(props);
		this.toggleVisibility = this.toggleVisibility.bind(this);
		this.state = {
			visible: false,
			switched: false,
			showOptions: false,
		};
	}

	componentDidUpdate(prevProps, prevState) {
		const { showOptions } = this.state;
		if (prevState.showOptions !== this.state.showOptions && this.props.getOptionsShown) {
			this.props.getOptionsShown(showOptions);
		}
	}

	toggleVisibility = () => {
		const { toggleCollectionItem, index } = this.props;
		toggleCollectionItem(index);
	};

	showOptions = e => {
		e.stopPropagation();
		this.setState({ showOptions: true });
	};

	closeOptions = e => {
		e.stopPropagation();
		if (this.state.showOptions) {
			this.setState({ showOptions: false });
		}
	};

	toggleOptions = e => {
		e.stopPropagation();
		const { showOptions } = this.state;
		this.setState({
			showOptions: !showOptions,
		});
	};

	moveUp = e => {
		e.stopPropagation();
		if (this.props.moveUp) {
			this.props.moveUp(this.props.index);
			this.setState({ showOptions: false });
		}
	};

	moveDown = e => {
		e.stopPropagation();
		if (this.props.moveDown) {
			this.props.moveDown(this.props.index);
			this.setState({ showOptions: false });
		}
	};

	copyCollection = e => {
		e.stopPropagation();
		if (this.props.copyCollection) {
			this.props.copyCollection(this.props.index);
			this.setState({ showOptions: false });
		}
	};

	deleteCollection = e => {
		e.stopPropagation();
		if (this.props.deleteCollection) {
			this.props.deleteCollection(this.props.index);
			this.setState({ showOptions: false });
		}
	};

	getOptionsWidth() {
		const { deleteCollection, copyCollection, moveUp, moveDown } = this.props;
		let count = 0;
		if (deleteCollection) {
			count++;
		}
		if (copyCollection) count++;
		if (moveUp) count++;
		if (moveDown) count++;
		return `on on-${count}`;
	}

	DragHandle = SortableHandle(() => {
		const { title, expanded, moveUp, moveDown, deleteCollection, copyCollection } = this.props;
		const isOpen = expanded ? "open" : "closed";
		return (
			<Panel.Title>
				<div className={`panel-toggle btn btn-primary ${isOpen}`}>
					<i className="fal fa-chevron-down icon"></i>
				</div>
				<div className={`collection-options ${this.state.showOptions ? this.getOptionsWidth() : ""}`}>
					<div
						className="collection-option toggler"
						onClick={e => {
							this.toggleOptions(e);
						}}
					>
						<i className="fal fa-ellipsis-v icon"></i>
					</div>
					{moveUp && (
						<div
							className={`collection-option${this.props.index === 0 ? " disabled" : ""}`}
							onClick={e => {
								if (this.props.index !== 0) this.moveUp(e);
							}}
						>
							<i className="fal fa-chevron-up"></i>
						</div>
					)}
					{moveDown && (
						<div
							className={`collection-option${
								this.props.index === this.props.totalCount - 1 ? " disabled" : ""
							}`}
							onClick={e => {
								if (this.props.index !== this.props.totalCount) this.moveDown(e);
							}}
						>
							<i className="fal fa-chevron-down"></i>
						</div>
					)}
					{copyCollection && (
						<div className="collection-option" onClick={e => this.copyCollection(e)}>
							<i className="fal fa-copy"></i>
						</div>
					)}
					{deleteCollection && (
						<div className="collection-option" onClick={e => this.deleteCollection(e)}>
							<i className="fal fa-trash"></i>
						</div>
					)}
				</div>
				<div className="module-name">
					<span style={{ color: "rgba(0,0,0,0)" }}>|</span> {title}
				</div>
			</Panel.Title>
		);
	});

	render() {
		const { expanded, children } = this.props;
		return (
			<Panel onToggle={this.toggleVisibility} expanded={expanded}>
				<Panel.Heading onClick={this.toggleVisibility} style={{ cursor: "pointer" }}>
					<this.DragHandle />
				</Panel.Heading>
				<Panel.Collapse>
					<Panel.Body>{children}</Panel.Body>
				</Panel.Collapse>
			</Panel>
		);
	}
}

CollectionAccordion.propTypes = {
	children: PropTypes.any,
	title: PropTypes.string,
	expanded: PropTypes.bool,
	toggleCollectionItem: PropTypes.any,
	index: PropTypes.number,
	totalCount: PropTypes.number,
	moveUp: PropTypes.func,
	moveDown: PropTypes.func,
	copyCollection: PropTypes.func,
	deleteCollection: PropTypes.func,
	getOptionsShown: PropTypes.func,
};

export default CollectionAccordion;
